// Persona (system_prompt) do H.Bot (Frente 3, G12) — editável só por ADMIN.
// Endpoint próprio `/admin/assistant/persona/` que resolve o agente GENERAL único
// server-side (o front não precisa descobrir o id).

import apiService from './api.service';
import { AssistantPersona, UpdateAssistantPersonaPayload } from '@/types/assistant';

class AssistantPersonaService {
  async get(): Promise<AssistantPersona> {
    const response = await apiService.get<AssistantPersona>('/admin/assistant/persona/');
    return response.data;
  }

  async update(payload: UpdateAssistantPersonaPayload): Promise<AssistantPersona> {
    const response = await apiService.patch<AssistantPersona>('/admin/assistant/persona/', payload);
    return response.data;
  }

  async restoreDefault(): Promise<AssistantPersona> {
    const response = await apiService.post<AssistantPersona>('/admin/assistant/persona/restore-default/');
    return response.data;
  }
}

export default new AssistantPersonaService();
